import { useState } from 'react'

import { CreateSpotifyCampaignResponse } from 'src/Redux/spotify-campaignApi'

import { useSpotifyArtistSearch } from '../../Components/SearchArtistSection/useSpotifyArtistSearch'
import { SearchArtistSectionProps } from '../../Components/SearchArtistSection'
import { useCreateNewCampaign } from '../../useCreateNewCampaign'

const CREATE_ERROR_MESSAGE =
  'We could not create your campaign. Please try again'

interface IPreReleaseTrackDetails extends SearchArtistSectionProps {
  createdCampaign: CreateSpotifyCampaignResponse | null
}

export const usePreReleaseTrackDetails = (): IPreReleaseTrackDetails => {
  const [createError, setCreateError] = useState('')
  const [createdCampaign, setCreatedCampaign] =
    useState<CreateSpotifyCampaignResponse | null>(null)

  const artistSearch = useSpotifyArtistSearch()
  const { selectedArtist, trackName } = artistSearch

  const { createNewPreReleaseSpotifyCampaign, loading: isCreating } =
    useCreateNewCampaign()

  const onCreateCampaign = (): void => {
    if (!selectedArtist) {
      return
    }

    setCreateError('')

    createNewPreReleaseSpotifyCampaign({
      artistName: selectedArtist.name,
      artistSpotifyId: selectedArtist.spotifyId,
      trackName: trackName.trim(),
    })
      .then((response) => {
        setCreatedCampaign(response)
      })
      .catch(() => {
        setCreateError(CREATE_ERROR_MESSAGE)
      })
  }

  return {
    ...artistSearch,
    createError,
    isCreating,
    createdCampaign,
    onCreateCampaign,
  }
}
